import { setAttributes } from '../utils/dom'

// Public types ---------------------------------------------------------------

export type CellPlaceholderParams = {
  readonly formatter: string
  readonly align?: 'right'
}

// Public functions -----------------------------------------------------------

/** Reuse the first-paint masks while AG Grid defers a complex cell. */
export const CellPlaceholder = ({
  formatter,
  align
}: CellPlaceholderParams): HTMLElement => {
  const element = document.createElement('div')
  setAttributes(element, {
    'data-part': 'grid-cell-placeholder',
    'data-formatter': formatter,
    'data-align': align,
    'aria-hidden': true
  })

  return element
}
